"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventParameters = exports.getFunctionParameters = exports.getContract = void 0;
const getAction_js_1 = require("../utils/getAction.js");
const createContractEventFilter_js_1 = require("./public/createContractEventFilter.js");
const estimateContractGas_js_1 = require("./public/estimateContractGas.js");
const getContractEvents_js_1 = require("./public/getContractEvents.js");
const readContract_js_1 = require("./public/readContract.js");
const simulateContract_js_1 = require("./public/simulateContract.js");
const watchContractEvent_js_1 = require("./public/watchContractEvent.js");
const writeContract_js_1 = require("./wallet/writeContract.js");
function getContract(_ref) {
  let {
    abi,
    address,
    publicClient,
    walletClient
  } = _ref;
  const hasPublicClient = publicClient !== undefined && publicClient !== null;
  const hasWalletClient = walletClient !== undefined && walletClient !== null;
  const contract = {};
  let hasReadFunction = false;
  let hasWriteFunction = false;
  let hasEvent = false;
  for (const item of abi) {
    if (item.type === 'function') {
      if (item.stateMutability === 'view' || item.stateMutability === 'pure') hasReadFunction = true;else hasWriteFunction = true;
    } else if (item.type === 'event') hasEvent = true;
    if (hasReadFunction && hasWriteFunction && hasEvent) break;
  }
  if (hasPublicClient) {
    if (hasReadFunction) contract.read = new Proxy({}, {
      get(_, functionName) {
        return function () {
          for (var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++) {
            parameters[_key] = arguments[_key];
          }
          const {
            args,
            options
          } = getFunctionParameters(parameters);
          return (0, getAction_js_1.getAction)(publicClient, readContract_js_1.readContract, 'readContract')(_objectSpread({
            abi,
            address,
            functionName,
            args
          }, options));
        };
      }
    });
    if (hasWriteFunction) contract.simulate = new Proxy({}, {
      get(_, functionName) {
        return function () {
          for (var _len2 = arguments.length, parameters = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            parameters[_key2] = arguments[_key2];
          }
          const {
            args,
            options
          } = getFunctionParameters(parameters);
          return (0, getAction_js_1.getAction)(publicClient, simulateContract_js_1.simulateContract, 'simulateContract')(_objectSpread({
            abi,
            address,
            functionName,
            args
          }, options));
        };
      }
    });
    if (hasEvent) {
      contract.createEventFilter = new Proxy({}, {
        get(_, eventName) {
          return function () {
            const abiEvent = abi.find(x => x.type === 'event' && x.name === eventName);
            for (var _len3 = arguments.length, parameters = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              parameters[_key3] = arguments[_key3];
            }
            const {
              args,
              options
            } = getEventParameters(parameters, abiEvent);
            return (0, getAction_js_1.getAction)(publicClient, createContractEventFilter_js_1.createContractEventFilter, 'createContractEventFilter')(_objectSpread({
              abi,
              address,
              eventName,
              args
            }, options));
          };
        }
      });
      contract.getEvents = new Proxy({}, {
        get(_, eventName) {
          return function () {
            const abiEvent = abi.find(x => x.type === 'event' && x.name === eventName);
            for (var _len4 = arguments.length, parameters = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              parameters[_key4] = arguments[_key4];
            }
            const {
              args,
              options
            } = getEventParameters(parameters, abiEvent);
            return (0, getAction_js_1.getAction)(publicClient, getContractEvents_js_1.getContractEvents, 'getContractEvents')(_objectSpread({
              abi,
              address,
              eventName,
              args
            }, options));
          };
        }
      });
      contract.watchEvent = new Proxy({}, {
        get(_, eventName) {
          return function () {
            const abiEvent = abi.find(x => x.type === 'event' && x.name === eventName);
            for (var _len5 = arguments.length, parameters = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              parameters[_key5] = arguments[_key5];
            }
            const {
              args,
              options
            } = getEventParameters(parameters, abiEvent);
            return (0, getAction_js_1.getAction)(publicClient, watchContractEvent_js_1.watchContractEvent, 'watchContractEvent')(_objectSpread({
              abi,
              address,
              eventName,
              args
            }, options));
          };
        }
      });
    }
  }
  if (hasWalletClient) {
    if (hasWriteFunction) contract.write = new Proxy({}, {
      get(_, functionName) {
        return function () {
          for (var _len6 = arguments.length, parameters = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            parameters[_key6] = arguments[_key6];
          }
          const {
            args,
            options
          } = getFunctionParameters(parameters);
          return (0, getAction_js_1.getAction)(walletClient, writeContract_js_1.writeContract, 'writeContract')(_objectSpread({
            abi,
            address,
            functionName,
            args
          }, options));
        };
      }
    });
  }
  if (hasPublicClient || hasWalletClient) if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
    get(_, functionName) {
      return function () {
        var _options$account;
        for (var _len7 = arguments.length, parameters = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          parameters[_key7] = arguments[_key7];
        }
        const {
          args,
          options
        } = getFunctionParameters(parameters);
        const client = publicClient !== null && publicClient !== void 0 ? publicClient : walletClient;
        return (0, getAction_js_1.getAction)(client, estimateContractGas_js_1.estimateContractGas, 'estimateContractGas')(_objectSpread(_objectSpread({
          abi,
          address,
          functionName,
          args
        }, options), {}, {
          account: (_options$account = options.account) !== null && _options$account !== void 0 ? _options$account : walletClient.account
        }));
      };
    }
  });
  contract.address = address;
  contract.abi = abi;
  return contract;
}
exports.getContract = getContract;
function getFunctionParameters(values) {
  var _ref2;
  const hasArgs = values.length && Array.isArray(values[0]);
  const args = hasArgs ? values[0] : [];
  const options = (_ref2 = hasArgs ? values[1] : values[0]) !== null && _ref2 !== void 0 ? _ref2 : {};
  return {
    args,
    options
  };
}
exports.getFunctionParameters = getFunctionParameters;
function getEventParameters(values, abiEvent) {
  var _ref3;
  let hasArgs = false;
  if (Array.isArray(values[0])) hasArgs = true;else if (values.length === 1) {
    hasArgs = abiEvent.inputs.some(x => x.indexed);
  } else if (values.length === 2) {
    hasArgs = true;
  }
  const args = hasArgs ? values[0] : undefined;
  const options = (_ref3 = hasArgs ? values[1] : values[0]) !== null && _ref3 !== void 0 ? _ref3 : {};
  return {
    args,
    options
  };
}
exports.getEventParameters = getEventParameters;
//# sourceMappingURL=getContract.js.map